import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { uniq } from 'lodash';
import { SliderThumb } from '@mui/material';
import { StyledSlider } from './styled';

const ThumbWrapper = ThumbComponent => props => {
  const { children, ...other } = props;
  return (
    <SliderThumb {...other}>
      {children}
      <ThumbComponent />
    </SliderThumb>
  );
};
const MARKS = [{ value: 0 }, { value: 100 }];

export const RangeSlider = ({
  marks = MARKS,
  step,
  min,
  max,
  colors,
  color = 'var(--slider-trail-color)',
  onChange,
  value = 0,
  sharpGradient = true,
  disabled,
  thumb,
  thumbColor = 'var(--slider-thumb-color)',
  valueLabelDisplay = 'off',
  valueLabelFormat
}) => {
  const slots = useMemo(() => (thumb ? { thumb: ThumbWrapper(thumb) } : undefined), [thumb]);
  const trailColors = useMemo(() => colors || uniq(marks?.map(m => m.color)), [colors, marks]);

  return (
    <StyledSlider
      value={value}
      onChange={onChange}
      marks={marks}
      disabled={disabled}
      disableSwap
      step={step}
      min={min}
      max={max}
      slots={slots}
      valueLabelDisplay={valueLabelDisplay}
      valueLabelFormat={valueLabelFormat}
      $trailColors={trailColors}
      $sharpGradient={sharpGradient}
      $color={color}
      $thumb={!!thumb}
      $thumbColor={thumbColor}
    />
  );
};

RangeSlider.propTypes = {
  marks: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      color: PropTypes.string,
      value: PropTypes.number
    })
  ),
  thumb: PropTypes.oneOfType([PropTypes.node, PropTypes.func, PropTypes.element]),
  step: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  colors: PropTypes.arrayOf(PropTypes.string),
  color: PropTypes.string,
  thumbColor: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  sharpGradient: PropTypes.bool,
  disabled: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),
  valueLabelFormat: PropTypes.func,
  valueLabelDisplay: PropTypes.oneOf(['auto', 'off', 'on'])
};
